/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Online_Price_ClearInputs */

const vi_online_price_clear = /** @type {(inputs: Online_Price_ClearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bỏ giá Online của ${i?.sku}`)
};

/**

* @param {Online_Price_ClearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_clear = /** @type {((inputs: Online_Price_ClearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_ClearInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_clear(inputs)
});